// 暂未使用
const isNullOrEmpty = function(val) {
    if (val == null || val == "" || typeof val == undefined) {
        return true;
    } else {
        return false;
    }
};

export { isNullOrEmpty,};



// WEBPACK FOOTER //
// ./src/filters/index.js